import React, { useState } from "react";
import type { CascaderProps } from "antd";
import { Cascader } from "antd";
import { DefaultOptionType } from "antd/es/cascader";
import Board from "./components/Board";
import { DropdownIconDark, DropdownIconPc } from "../MultiSelect/assets";
import styles from "./style/index.module.scss";
import classNames from "classnames";

type SingleSelectProps = {
  onReset?: () => void;
  clear_text?: string;
  options: any[];
  wrapperClassName?: string;
  showReset?: boolean;
  arrowIconStyle?: "default" | "dark";
};

const SingleSelectPc = ({
  options,
  multiple,
  onChange,
  onReset,
  clear_text,
  wrapperClassName,
  showReset = true,
  placeholder,
  arrowIconStyle = "default",
  ...rest
}: CascaderProps<DefaultOptionType> & SingleSelectProps) => {
  const [open, setOpen] = useState(false);

  // console.log("rest", rest);
  const handleReset = () => {
    if (onReset) {
      onReset();
    }
    setOpen(false);
  };

  return (
    <div
      className={classNames(
        {
          [styles.overrideCascader]: true,
          [styles.overrideSascaderActive]: open
        },
        "overrideCascaderNew",
        wrapperClassName
      )}
    >
      <Cascader
        options={options}
        popupClassName={styles.popupClz}
        onChange={onChange}
        placeholder={placeholder || "Please select"}
        allowClear={false}
        suffixIcon={arrowIconStyle === "dark" ? <DropdownIconDark /> : <DropdownIconPc />}
        open={open}
        // open={true}
        onDropdownVisibleChange={(visible) => setOpen(visible)}
        getPopupContainer={(node) => node.parentElement}
        dropdownRender={(menu) => (
          <>
            {menu}
            {showReset && <Board onReset={handleReset} clear_text={clear_text} />}
          </>
        )}
        {...rest}
      />
    </div>
  );
};

export default SingleSelectPc;
